import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SubAccount } from '../models/sub_account_model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class SubAccountService {

  constructor(
    private http: HttpClient
  ) { }

  createSubAccount(subAccount: SubAccount): Observable<SubAccount> {
    return this.http.post<SubAccount>(`${environment.apiBaseUrl}/subAccounts/createSubAccount`, subAccount);
  }

  updateSubAccount(id: string, subAccount: Partial<SubAccount>): Observable<SubAccount> {
    return this.http.put<SubAccount>(`${environment.apiBaseUrl}/subAccounts/updateSubAccount`, subAccount);
  }


  deleteSubAccount(id: string): Observable<any> {
    return this.http.delete<any>(`${environment.apiBaseUrl}/subAccounts/deleteSubAccount/${id}`);
  }
  getSubAccount(query: object): Observable<SubAccount> {
    return this.http.post<SubAccount>(`${environment.apiBaseUrl}/subAccounts/getSubAccount`, query)
  }

  getSubAccounts(query: object): Observable<SubAccount[]> {
    return this.http.post<SubAccount[]>(`${environment.apiBaseUrl}/subAccounts/getSubAccounts`, query);
  }

}
